import Icon from '../components/Icon.vue'

Icon.register({"diamond":{"width":2048,"height":1792,"paths":[{"d":"M212 768l623 665-300-665h-323zM1024 1540l349-772h-698zM538 640l204-384h-262l-288 384h346zM1213 1433l623-665h-323zM683 640h682l-204-384h-274zM1510 640h346l-288-384h-262zM1651 154l384 512q14 18 13 41.5t-17 40.5l-960 1024q-18 20-47 20t-47-20l-960-1024q-16-17-17-40.5t13-41.5l384-512q18-26 51-26h1152q33 0 51 26z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/diamond.js
// module id = 1325
// module chunks = 0